<template>
  <vue-modal
    @before-close="beforeClose"
    @before-open="beforeOpen"
    :click-to-close="false"
    :delay="100"
    :scrollable="false"
    :classes="['ugc-modal', {
      'ugc-new-modal-layout': showNewConfirmDesignComponents,
    }]"
    name="ugcModal"
    ref="vueModal"
    :style="modalStyles"
  >
    <ugc-new-topbar
      :class="{
        hide: !showNewConfirmDesignComponents,
      }"
      @close="close"
    ></ugc-new-topbar>
    <ugc-topbar
      ref="ugcTopBar"
      :class="{
        hide: showNewConfirmDesignComponents
      }"
    ></ugc-topbar>
    <component :is="activeViewComponent"></component>
    <ugc-go-back-button
      ref="ugcBackButton"
      :class="{
        hide: showNewConfirmDesignComponents
      }"
    ></ugc-go-back-button>
    <ugc-bottom-bar
      :class="{
        hide: !showNewConfirmDesignComponents
      }"
      @go-back="goBack"
      @next="next"
      @finish="finish"
    ></ugc-bottom-bar>
  </vue-modal>
</template>

<script>
import ugcDesignView from '@/components/UGC/UGCMainComponents/DesignView';
import ugcAlmostDone from '@/components/UGC/UGCMainComponents/AlmostDone';
import ugcConfirmDesign from '@/components/UGC/UGCMainComponents/ConfirmDesign';
import ugcNewConfirmDesign from '@/components/UGC/UGCMainComponents/NewConfirmDesign';
import ugcTopbar from '@/components/UGC/TopBar';
import ugcNewTopbar from '@/components/UGC/UGCMainComponents/NewTopBar';
import ugcGoBackButton from '@/components/UGC/GoBackButton';
import ugcBottomBar from '@/components/UGC/UGCMainComponents/BottomBar';

export default {
  name: "UgcModal",
  components: {
    ugcDesignView,
    ugcAlmostDone,
    ugcConfirmDesign,
    ugcNewConfirmDesign,
    ugcTopbar,
    ugcNewTopbar,
    ugcGoBackButton,
    ugcBottomBar,
  },
  data() {
    return {
      modalStyles: {},
    };
  },
  computed: {
    showNewConfirmDesignComponents() {
      return this.$store.state.utils.configuration.enableNewConfirmDesignComponent && this.activeViewComponent === 'ugc-new-confirm-design';
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    activeViewComponent() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCView;
    }
  },
  watch: {
    activeViewComponent() {
      this.adjustModalHeight();
    }
  },
  methods: {
    beforeClose() {
      this.$store.commit("ugc/stateManager/SET_LOADING", false);
      this.$store.commit("ugc/tempData/SET_UPLOAD_ANOTHER", null);
      this.$store.commit("ugc/tempData/SET_SELECT_ANOTHER", null);
    },
    beforeOpen() {
      this.$store.dispatch("ugc/CREATE_UGC_FLOW_VIEWS");
      this.$eventBus.$emit("ugc-modal-open");
    },
    close() {
      this.$refs.ugcTopBar.exit();
    },
    goBack() {
      this.$refs.ugcBackButton.goBack();
    },
    next() {
      this.$refs.ugcTopBar.checkPlacement();
    },
    finish() {
      this.$refs.ugcTopBar.finish();
    },
    adjustModalHeight() {
      const height = window.innerHeight;
      this.modalStyles = this.showNewConfirmDesignComponents ? {
        ...this.modalStyles,
        maxHeight: `${height}px`,
      } : {};
    },
  },
  created() {
    window.addEventListener('resize', this.adjustModalHeight);
  },
  mounted() {
    this.adjustModalHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustModalHeight);
  },
};
</script>
